import React from "react";
import { NamedProperty } from "sprint-common-web";

import { VersionSummary } from "../../../../../common/types/VersionSummary";
import { PageHeader } from "../../../../../common/ui/layout/header/PageHeader";
import { TvSeriesDetailsPageBreadcrumbs } from "../../../common/header/tv-series/TvSeriesDetailsPageBreadcrumbs";

interface TvSeriesDetailsPageHeaderProps {
    tvSeries: NamedProperty;
    season: NamedProperty;
    episode: NamedProperty;
    version: VersionSummary;
}

export const OnPremTvSeriesDetailsPageHeader: React.FunctionComponent<TvSeriesDetailsPageHeaderProps> = (
    props: TvSeriesDetailsPageHeaderProps
) => {
    const { tvSeries, season, episode, version } = props;

    return (
        <PageHeader>
            <TvSeriesDetailsPageBreadcrumbs tvSeries={tvSeries} season={season} episode={episode} version={version} />
        </PageHeader>
    );
};
